import { AnyAction } from 'redux';
import { collectionReducer } from '../../../redux/collection-reducer';
import { ADD_KEY_TAX_DIRECTIVE, UPDATE_KEY_TAX_DIRECTIVE } from './types';
import { State } from '../../../redux/root-reducer';
import { getProperty } from '../../../claim';

export interface KeyTaxDirective {
    id?: string;
    dateRequested?: Date;
    dateReturned?: Date;
    startDate?: Date;
    endDate?: Date;
    assessorName: string;
    keyTaxReferenceNumber: string;
    decisionId?: string;
    amountReturned?: number;
    sourceCode: string;
    amountApplied?: string;
    status?: string;
}

export const defaultKeyTaxDirectiveReducerReducer: KeyTaxDirective[] = [];

export const keyTaxDirectiveReducer = collectionReducer<KeyTaxDirective>({
    addAction: ADD_KEY_TAX_DIRECTIVE,
    updateAction: UPDATE_KEY_TAX_DIRECTIVE,
});

export function defaultKeyTaxDirectiveReducer(state: KeyTaxDirective[] = [], action: AnyAction) {
    switch (action.type) {
        default:
            return state;
    }
}

export function getIndex(state: State): number {
    return !!state.formModal.activeModal ? state.formModal.activeModal.modalData : -1;
}

export const getKeyTaxDirectives = (keyTaxDirectives: KeyTaxDirective[]) => {
    // return current dependants and the 'Other' option
    const keyDirectives = keyTaxDirectives.map(keyTaxDirective => {
        return { value: keyTaxDirective.id };
    });

    return keyDirectives;
};
export interface KeyTaxDirectiveSummary {
    readonly records: KeyTaxDirective[];
}

export const defaultRecords: KeyTaxDirective[] = [];
// export const defaulInformationRequired: KeyTaxDirectiveSummary = {
//     records: defaultRecords,
// };
// export function (state: State): KeyTaxDirectiveSummary {
//     return getProperty(state, 'keyTaxDirective', defaulInformationRequired);
// }

export function getKeyTaxDirective(state: State): KeyTaxDirective[] {
    return getProperty(state, 'keyTaxDirective', defaultRecords);
}
